"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.borrowFlashLoanInstruction = void 0;
const spl_token_1 = require("@solana/spl-token");
const web3_js_1 = require("@solana/web3.js");
const buffer_layout_1 = require("buffer-layout");
const util_1 = require("../util");
const instruction_1 = require("./instruction");
const DataLayout = (0, buffer_layout_1.struct)([(0, buffer_layout_1.u8)("instruction"), (0, util_1.u64)("liquidityAmount")]);
const borrowFlashLoanInstruction = (liquidityAmount, sourceLiquidity, destinationLiquidity, liquidityReserve, flashLoanFeeReceiver, hostFeeReceiver, lendingMarket, lendingMarketAuthority, flashLoanProgram, transferAuthority, lendingProgram) => {
    const data = Buffer.alloc(DataLayout.span);
    DataLayout.encode({
        instruction: instruction_1.LendingInstruction.FlashLoan,
        liquidityAmount: BigInt(liquidityAmount),
    }, data);
    const keys = [
        ///   0. `[writable]` Source liquidity token account.
        { pubkey: sourceLiquidity, isSigner: false, isWritable: true },
        ///   1. `[writable]` Destination liquidity token account.
        { pubkey: destinationLiquidity, isSigner: false, isWritable: true },
        ///   2. `[writable]` Reserve account.
        { pubkey: liquidityReserve, isSigner: false, isWritable: true },
        ///   3. `[writable]` Flash loan fee receiver account.
        { pubkey: flashLoanFeeReceiver, isSigner: false, isWritable: true },
        ///   4. `[writable]` Host fee receiver.
        { pubkey: hostFeeReceiver, isSigner: false, isWritable: true },
        ///   5. `[]` Lending market account.
        { pubkey: lendingMarket, isSigner: false, isWritable: false },
        ///   6. `[]` Derived lending market authority.
        { pubkey: lendingMarketAuthority, isSigner: false, isWritable: false },
        ///   7. `[]` Token program id.
        { pubkey: spl_token_1.TOKEN_PROGRAM_ID, isSigner: false, isWritable: false },
        ///   8. `[]` Flash loan receiver program id.
        { pubkey: flashLoanProgram, isSigner: false, isWritable: false },
        ///   9. `[signer]` user transfer authority.
        { pubkey: transferAuthority, isSigner: true, isWritable: false },
    ];
    return new web3_js_1.TransactionInstruction({
        keys,
        programId: lendingProgram,
        data,
    });
};
exports.borrowFlashLoanInstruction = borrowFlashLoanInstruction;
